var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlayerUnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1769 0.717353C11.6752 0.969577 12 1.56378 12 2.22287V21.7776C12 22.4367 11.6752 23.0309 11.1769 23.2831C10.6787 23.5354 10.1052 23.3959 9.72386 22.9298L4.78106 16.8889H1.33333C0.596961 16.8889 0 16.1593 0 15.2593V8.74112C0 7.84113 0.596961 7.11156 1.33333 7.11156H4.78106L9.72386 1.07059C10.1052 0.604539 10.6787 0.46513 11.1769 0.717353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2086 0.477282C18.7294 -0.159094 19.5735 -0.159094 20.0943 0.477282C22.5057 3.42443 23.9995 7.50056 23.9995 12C23.9995 16.4995 22.5057 20.5757 20.0943 23.5227C19.5735 24.1591 18.7294 24.1591 18.2086 23.5227C17.6879 22.8864 17.6879 21.8546 18.2086 21.2182C20.1404 18.8573 21.3328 15.6005 21.3328 12C21.3328 8.39964 20.1404 5.14275 18.2086 2.78183C17.6879 2.14545 17.6879 1.11366 18.2086 0.477282ZM14.4374 5.08638C14.958 4.44999 15.8023 4.44999 16.323 5.08638C17.0242 5.94334 17.5963 6.95966 17.9999 8.08848C18.4288 9.28839 18.6662 10.6125 18.6662 12C18.6662 14.6995 17.7692 17.1461 16.323 18.9137C15.8023 19.55 14.958 19.55 14.4374 18.9137C13.9167 18.2773 13.9167 17.2455 14.4374 16.6092C15.404 15.4277 15.9995 13.8005 15.9995 12C15.9995 11.07 15.841 10.1895 15.5563 9.39333C15.2879 8.64253 14.9064 7.96413 14.4374 7.39093C13.9167 6.75455 13.9167 5.72276 14.4374 5.08638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3L25 21",
    stroke: "white",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayerUnabled);
export default __webpack_public_path__ + "static/media/audio_player_unabled.01096c2a3e48503d3c79519df7b33375.svg";
export { ForwardRef as ReactComponent };